/* tslint:disable */
/* eslint-disable */
/**
 * PopshopLive API
 * PopshopLive API service
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    AuthUrlResponse,
    OAuth2AuthRequest,
} from '../models';

export interface OAuth2ApiControllerAuthorizeGoogleCalendarRequest {
    oAuth2AuthRequest: OAuth2AuthRequest;
}

export interface OAuth2ApiControllerGetGoogleCalendarAuthorizationUrlRequest {
    redirectUri: string;
    state: string;
}

/**
 * 
 */
export class OAuth2Api extends runtime.BaseAPI {

    /**
     */
    async oAuth2ApiControllerAuthorizeGoogleCalendarRaw(requestParameters: OAuth2ApiControllerAuthorizeGoogleCalendarRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.oAuth2AuthRequest === null || requestParameters.oAuth2AuthRequest === undefined) {
            throw new runtime.RequiredError('oAuth2AuthRequest','Required parameter requestParameters.oAuth2AuthRequest was null or undefined when calling oAuth2ApiControllerAuthorizeGoogleCalendar.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/google-calendar/authorize`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.oAuth2AuthRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async oAuth2ApiControllerAuthorizeGoogleCalendar(requestParameters: OAuth2ApiControllerAuthorizeGoogleCalendarRequest): Promise<void> {
        await this.oAuth2ApiControllerAuthorizeGoogleCalendarRaw(requestParameters);
    }

    /**
     */
    async oAuth2ApiControllerGetGoogleCalendarAuthorizationUrlRaw(requestParameters: OAuth2ApiControllerGetGoogleCalendarAuthorizationUrlRequest): Promise<runtime.ApiResponse<AuthUrlResponse>> {
        if (requestParameters.redirectUri === null || requestParameters.redirectUri === undefined) {
            throw new runtime.RequiredError('redirectUri','Required parameter requestParameters.redirectUri was null or undefined when calling oAuth2ApiControllerGetGoogleCalendarAuthorizationUrl.');
        }

        if (requestParameters.state === null || requestParameters.state === undefined) {
            throw new runtime.RequiredError('state','Required parameter requestParameters.state was null or undefined when calling oAuth2ApiControllerGetGoogleCalendarAuthorizationUrl.');
        }

        const queryParameters: any = {};

        if (requestParameters.redirectUri !== undefined) {
            queryParameters['redirectUri'] = requestParameters.redirectUri;
        }

        if (requestParameters.state !== undefined) {
            queryParameters['state'] = requestParameters.state;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/google-calendar/authorization-url`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async oAuth2ApiControllerGetGoogleCalendarAuthorizationUrl(requestParameters: OAuth2ApiControllerGetGoogleCalendarAuthorizationUrlRequest): Promise<AuthUrlResponse> {
        const response = await this.oAuth2ApiControllerGetGoogleCalendarAuthorizationUrlRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async oAuth2ApiControllerUnauthorizeGoogleCalendarRaw(): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/google-calendar/unauthorize`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async oAuth2ApiControllerUnauthorizeGoogleCalendar(): Promise<void> {
        await this.oAuth2ApiControllerUnauthorizeGoogleCalendarRaw();
    }

}
